import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { ApplicationEventFilterAreaInteractionType } from '~shared/modules/application-event/constants';

export class GATrackingPLPPriceFilterInteractionEvent implements GATrackingEvent {

  constructor(private priceInteractionType: ApplicationEventFilterAreaInteractionType) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PLPPriceFilterInteraction;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PLPPriceFilter,
      label: this.priceInteractionType
    };
  }
}
